var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6",
    d: "M1 1H21.8723V20C21.8723 22.2091 20.0815 24 17.8723 24H5.00001C2.79087 24 1 22.2091 1 20V1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.97266 7.53882C7.57529 7.53882 8.06537 8.08607 8.06537 8.75901C8.06537 9.0964 8.30959 9.36911 8.61173 9.36911C8.91387 9.36911 9.15809 9.0964 9.15809 8.75901C9.15809 7.41314 8.17792 6.31862 6.97266 6.31862C5.7674 6.31862 4.78723 7.41314 4.78723 8.75901C4.78723 9.0964 5.03145 9.36911 5.33359 9.36911C5.63572 9.36911 5.87995 9.0964 5.87995 8.75901C5.87995 8.08668 6.37003 7.53882 6.97266 7.53882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3534 9.36911C17.6556 9.36911 17.8998 9.0964 17.8998 8.75901C17.8998 7.41314 16.9196 6.31862 15.7144 6.31862C14.5091 6.31862 13.5289 7.41314 13.5289 8.75901C13.5289 9.0964 13.7732 9.36911 14.0753 9.36911C14.3774 9.36911 14.6216 9.0964 14.6216 8.75901C14.6216 8.08607 15.1117 7.53882 15.7144 7.53882C16.317 7.53882 16.8071 8.08607 16.8071 8.75901C16.8071 9.0964 17.0513 9.36911 17.3534 9.36911Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7143 8.14891C15.4122 8.14891 15.168 8.42162 15.168 8.75901V12.4196C15.168 14.774 13.4519 16.6903 11.3435 16.6903C9.23509 16.6903 7.51898 14.774 7.51898 12.4196V8.75901C7.51898 8.42162 7.27476 8.14891 6.97263 8.14891C6.67049 8.14891 6.42627 8.42162 6.42627 8.75901V12.4196C6.42627 15.4475 8.63191 17.9105 11.3435 17.9105C14.0551 17.9105 16.2607 15.4475 16.2607 12.4196V8.75901C16.2607 8.42162 16.0165 8.14891 15.7143 8.14891Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.63ab3f96c3140603db27c0b6ff2c9bdd.svg";
export { ForwardRef as ReactComponent };